interface WaveDividerProps {
  position: 'top' | 'bottom'
  fillColor?: string
  className?: string
}

export function WaveDivider({ position, fillColor = '#F5F7FA', className = '' }: WaveDividerProps) {
  if (position === 'top') {
    return (
      <div className={`relative -mt-1 ${className}`} aria-hidden="true">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full h-16">
          <path
            d="M0,80 L0,40 Q180,0 360,30 T720,20 T1080,35 T1440,15 L1440,80 Z"
            fill={fillColor}
          />
        </svg>
      </div>
    )
  }

  return (
    <div className={`relative -mb-1 ${className}`} aria-hidden="true">
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" className="w-full h-16">
        <path
          d="M0,0 L0,50 Q180,80 360,45 T720,60 T1080,40 T1440,65 L1440,0 Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}